import * as React from "react"
import { useTranslation } from "react-i18next"

import { DEFAULT_TAGS } from "shared/hubrise/utils/tags"

import { IconDefault, IconInterdiction, IconOverlap, StyledTags, StyledToolTip } from "./Styles"

interface TagsProps {
  tags: Array<string>
  className?: string
  withToolTip?: boolean
}

const Tags = ({ tags, className, withToolTip = false }: TagsProps): JSX.Element | null => {
  const { t } = useTranslation()

  const defaultTags = DEFAULT_TAGS.filter((tag) => tags.includes(tag))
  if (defaultTags.length === 0) return null

  return (
    <StyledTags className={className}>
      {defaultTags.map((tag, index) => {
        const Tag = () => {
          switch (tag) {
            case "alcoholic":
              return <IconDefault>🍸</IconDefault>
            case "deal_only":
              return <IconDefault>🏷️</IconDefault>
            case "spicy_1":
              return <IconOverlap>🌶</IconOverlap>
            case "spicy_2":
              return <IconOverlap>🌶🌶</IconOverlap>
            case "spicy_3":
              return <IconOverlap>🌶🌶🌶</IconOverlap>
            case "gluten_free":
              return <IconInterdiction>🌾</IconInterdiction>
            case "vegan":
              return <IconDefault>🌱</IconDefault>
            case "vegetarian":
              return <IconDefault>🥕</IconDefault>
            case "half_half":
              return <IconOverlap>🍕🍕</IconOverlap>
          }
        }
        return withToolTip ? (
          <StyledToolTip label={t(`tags.default.${tag}`)} key={index}>
            <Tag />
          </StyledToolTip>
        ) : (
          <Tag key={index} />
        )
      })}
    </StyledTags>
  )
}

export default Tags
